import { createAsyncThunk } from '@reduxjs/toolkit'
import { receiveEntities } from '@actions/entity_actions.js'
import ShareableWebAPI from '@api/shareable_web_api.js'
import { serializableError } from '@utils/serializable_error.ts'

export const loadShareable = createAsyncThunk('sharing/loadShareable', async (obj, thunkAPI) => {
  const { shareableType, shareableId } = obj
  const { dispatch, rejectWithValue } = thunkAPI
  try {
    const response = await ShareableWebAPI.loadShareable(shareableId, shareableType)
    dispatch(handleLoadShareableSuccess(response, shareableId, shareableType))
    // Note: Anything returned here becomes the payload of fulfilled action
  } catch (error) {
    return rejectWithValue(serializableError(error))
  }
})

export const handleLoadShareableSuccess = (response, shareableId, shareableType) => {
  return dispatch => {
    const responseData = response.data
    const entities = responseData.entities
    dispatch(receiveEntities(entities))
  }
}
